module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "mt-4"
  }, [_vm._v("Custom Fields")]), _vm._v(" "), (!_vm.projectsLoading) ? _c('div', [(_vm.attributes.length > 0) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('strong', [_vm._v("Field name")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('strong', [_vm._v("Project name")])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.activeAttributes), function(attribute) {
    return _c('b-row', {
      key: attribute.attribute_id,
      staticClass: "mb-1 mt-1"
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_vm._v("\n        " + _vm._s(attribute.name) + "\n      ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_vm._v("\n        " + _vm._s(_vm.projectLookup[attribute.atlassian_project_id].name) + "\n      ")]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('b-button', {
      attrs: {
        "variant": "danger",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.deleteAttribute(attribute.attribute_id)
        }
      }
    }, [_vm._v("Delete field")])], 1)], 1)
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2 mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [(!_vm.showNewAttributeForm) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.enableNewAttributeForm
    }
  }, [_vm._v("New field")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showNewAttributeForm) ? _c('div', {
    staticClass: "form-group mt-2 mb-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "attribute-name",
      "placeholder": "Attribute name"
    },
    model: {
      value: (_vm.newAttributeName),
      callback: function($$v) {
        _vm.newAttributeName = $$v
      },
      expression: "newAttributeName"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": "Select project",
      "options": _vm.projectsArray
    },
    model: {
      value: (_vm.newAttributeProject),
      callback: function($$v) {
        _vm.newAttributeProject = $$v
      },
      expression: "newAttributeProject"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.typeOptions
    },
    model: {
      value: (_vm.newAttributeType),
      callback: function($$v) {
        _vm.newAttributeType = $$v
      },
      expression: "newAttributeType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-button-group', [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.shouldDisableSubmitButton
    },
    on: {
      "click": _vm.createAttribute
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('b-button', {
    on: {
      "click": _vm.disableNewAttributeForm
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), (_vm.newAttributeType === 'select') ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "Add up to 10 options",
      "aria-describedby": "input-live-feedback",
      "state": _vm.nameState
    },
    model: {
      value: (_vm.attributeOptionToAdd),
      callback: function($$v) {
        _vm.attributeOptionToAdd = $$v
      },
      expression: "attributeOptionToAdd"
    }
  }), _vm._v(" "), _c('b-form-invalid-feedback', {
    attrs: {
      "id": "input-live-feedback"
    }
  }, [_vm._v("\n              Enter no more than 75 characters\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.shouldDisableAddButton,
      "variant": "info"
    },
    on: {
      "click": _vm.addAttributeOption
    }
  }, [_vm._v("Add")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, _vm._l((_vm.newAttributeOptions), function(opt) {
    return _c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(opt))])
  }))], 1) : _vm._e()], 1) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-442ab0cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/CustomAttributesView.vue
// module id = 1009
// module chunks = 1